import { useState, useCallback } from 'react';
import Layout from '../../../Components/Layout/Layout';
import { Container, Spinner } from 'react-bootstrap';
import { AiOutlineSearch } from 'react-icons/ai';
import { BiTimeFive, BiLocationPlus } from 'react-icons/bi';
import InputGroup from 'react-bootstrap/InputGroup';
import Form from 'react-bootstrap/Form';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { imgUrl } from '../../../Helpers/Constant';
import { useGetEventList } from '../apiEndpoins/eventApiEndpoints';
import { debounce } from '../../../Components/Common/debounce';
const EventList = () => {
  const [searchValue, setSearchValue] = useState<string>('');
  const { data, isLoading } = useGetEventList(searchValue);
  const handleSearch = useCallback(
    debounce((value: string) => {
      setSearchValue(value);
    }, 500),
    []
  );
  return (
    <>
      <Layout pathName='BEI 2025 Events' showHeader>
        <div>
          <Container>
            <div className='section-title breadcrumb-card d-flex flex-mo-column align-items-center  justify-content-between'>
              <div className='text-start w-50'>
                <h2 className='mb-0'>All Events </h2>
              </div>
              <div className='w-50 d-flex flex-mo-column justify-content-end'>
                <div className='filter-parent'>
                  <InputGroup>
                    <InputGroup.Text id='basic-addon1'>
                      <AiOutlineSearch />
                    </InputGroup.Text>
                    <Form.Control
                      placeholder='Search Event'
                      aria-label='Username'
                      onChange={(e) => handleSearch(e.target.value)}
                      aria-describedby='basic-addon1'
                    />
                  </InputGroup>
                </div>
              </div>
            </div>

            {isLoading ? (
              <div className='text-center'>
                <Spinner
                  variant='primary'
                  style={{ height: '50px', width: '50px' }}
                />
              </div>
            ) : (
              <>
                {data?.data?.length ? (
                  <div
                    className='grid-container'
                    style={{
                      display: 'grid',
                      gridTemplateColumns:
                        'repeat(auto-fill, minmax(300px, 1fr))',
                      gap: '1rem',
                      alignItems: 'start',
                    }}
                  >
                    {data?.data?.map((sEvent) => {
                      return (
                        <Link
                          key={sEvent.event_id}
                          to={`/event-list/${sEvent.event_id}`}
                          style={{ textDecoration: 'none' }}
                        >
                          <div
                            className='grid-item'
                            style={{
                              background: 'white',
                              height: '100%',
                              breakInside: 'avoid',
                              position: 'relative',
                              borderRadius: '5px',
                            }}
                          >
                            <div
                              className='events-card-bg w-100 h-100'
                              onClick={() => {}}
                            >
                              <>
                                <div
                                  className='event_wrapper'
                                  style={{
                                    height: '200px',
                                    border: '1px solid #5278AB',
                                    borderTopRightRadius: '5px',
                                    borderTopLeftRadius: '5px',
                                  }}
                                >
                                  <img
                                    height={'197px'}
                                    className='event-img'
                                    alt={sEvent?.event_photo}
                                    src={
                                      sEvent.event_photo
                                        ? `${imgUrl}/${sEvent?.event_photo}`
                                        : '/blank-image.png'
                                    }
                                  />
                                </div>

                                <div className='fs-6'>
                                  <p className=''>
                                    <div className='event_venue  ps-1 pb-1'>
                                      <div>
                                        <BiLocationPlus color='white' />
                                        <span>{sEvent.event_venu}</span>
                                      </div>
                                      <div>
                                        <BiTimeFive color='white' size={14} />
                                        <span>
                                          {moment(
                                            sEvent.event_start_time,
                                            'HH:mm:ss'
                                          ).format('hh:mm A')}{' '}
                                          {sEvent.event_end_time && (
                                            <>
                                              - {''}
                                              {moment(
                                                sEvent.event_end_time,
                                                'HH:mm:ss'
                                              ).format('hh:mm A')}
                                            </>
                                          )}
                                        </span>
                                      </div>
                                    </div>
                                  </p>
                                </div>
                              </>

                              <div
                                style={{
                                  borderBottom: '1px solid gray',
                                  borderRight: '1px solid gray',
                                  borderLeft: '1px solid gray',
                                  borderBottomRightRadius: '5px',
                                  borderBottomLeftRadius: '5px',
                                }}
                                className='product_title d-flex flex-column gap-2'
                              >
                                <p
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'start',
                                    alignItems: 'center',
                                    gap: 3,
                                    color: '#3b2020',
                                    lineHeight: 0.9,
                                    minHeight: '30px',
                                  }}
                                >
                                  {sEvent.event_title}
                                </p>
                              </div>
                            </div>
                          </div>
                        </Link>
                      );
                    })}
                  </div>
                ) : (
                  <p className='text-center fs-4 fw-bold'>No event found</p>
                )}
              </>
            )}
          </Container>
        </div>
      </Layout>
    </>
  );
};

export default EventList;
